import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function PricingCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section id="pricing" className="w-full" style={{
    backgroundColor: '#0B1A2E'
  }} data-id="element-90">
      {/* Top stitch */}
      <div style={{
      borderTop: '3px dashed #D4A017',
      opacity: 0.3
    }} data-id="element-91" />

      <div className="max-w-3xl mx-auto px-6 py-12 md:py-18 text-center" ref={ref} data-id="element-92">
        {/* Objection handling */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-93">
          <p className="font-body text-lg md:text-xl leading-relaxed mb-4" style={{
          color: 'rgba(250, 243, 232, 0.8)'
        }} data-id="element-94">
            No necesitas un diploma.
          </p>
          <p className="font-body text-lg md:text-xl leading-relaxed mb-4" style={{
          color: 'rgba(250, 243, 232, 0.8)'
        }} data-id="element-95">
            No necesitas una máquina industrial.
          </p>
          <p className="font-serif-display font-bold text-2xl md:text-3xl leading-snug mb-8" style={{
          color: '#FAF3E8'
        }} data-id="element-96">
            Solo necesitas este manual y las ganas de no volver a preocuparte
            por el dinero a fin de mes.
          </p>
        </motion.div>

        {/* Stitch */}
        <hr className="stitch-divider mb-8" data-id="element-97" />

        {/* Price */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-98">
          <p className="font-body text-sm uppercase tracking-widest mb-3" style={{
          color: '#D4A017'
        }} data-id="element-99">
            Precio especial
          </p>
          <div className="flex items-center justify-center gap-4 mb-2" data-id="element-100">
            <span className="font-serif-display font-bold text-3xl md:text-4xl line-through" style={{
            color: 'rgba(250, 243, 232, 0.35)'
          }} data-id="element-101">
              $27
            </span>
            <span className="inline-block px-3 py-1 rounded-lg text-sm font-bold font-body" style={{
            backgroundColor: '#C0392B',
            color: '#fff'
          }} data-id="element-102">
              -76% OFF
            </span>
          </div>
          <p className="font-serif-display font-bold text-7xl md:text-8xl mb-4" style={{
          color: '#D4A017'
        }} data-id="element-103">
            $6.39
          </p>
          <p className="font-serif-display italic text-lg md:text-xl mb-8" style={{
          color: 'rgba(250, 243, 232, 0.55)'
        }} data-id="element-104">
            (Un solo ruedo de pantalón que hagas hoy paga este libro)
          </p>
        </motion.div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        delay: 0.35
      }} data-id="element-105">
          <motion.a href="https://manosquegeneran.com/cart/48283475017955:1" target="_blank" rel="noopener noreferrer" className="cta-glow inline-flex items-center justify-center gap-3 px-10 py-5 rounded-xl font-bold text-xl font-body transition-transform duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 active:scale-95" style={{
          backgroundColor: '#D4A017',
          color: '#1A1A1A'
        }} whileHover={{
          scale: 1.04
        }} whileTap={{
          scale: 0.96
        }} aria-label="Descarga el Método Express por $6.39" data-id="element-106">
            Descarga el Método Express —{' '}
            <span className="line-through opacity-60 text-lg" data-id="element-107">$27</span> $6.39
          </motion.a>

          <p className="mt-5 text-sm font-body" style={{
          color: 'rgba(250, 243, 232, 0.4)'
        }} data-id="element-108">
            Descarga digital instantánea · PDF + Videos · Sin suscripción
          </p>
        </motion.div>

        {/* Bottom decorative thread */}
        <div className="mt-10" data-id="element-109">
          <hr className="stitch-divider-wide" data-id="element-110" />
        </div>
      </div>
    </section>;
}